import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SendAllEmailComponent } from './send-all-email.component';

const routes: Routes = [{ path: '', component: SendAllEmailComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SendAllEmailRoutingModule { }
